export enum PanelSection{
    BasicDetails="Basic Details",
    Identifiers="Identifiers",
    Consent="Consent",
    Allergies ="Allergies",
    ClinicalInformation = "Clinical Information",
    Contacts = "Contacts"
}

export enum ContactSection{
    Facility = "Facility",
    Prescriber = "Prescriber",
    Pharmacist = "Pharmacist"
}
